import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {Input} from "../../../../../../shadCn/components/ui/input";
import DiligenceInfo from "../../../../../../components/slide/sub/diligence/DiligenceInfo";
import CommonPagination from "../../../../../../components/table/movable/CommonPagination";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../../../components/pageTabs/pageTabsStorage";
import "../../../../../../components/js-grid/simmsListThumb.css";

function normalizeRows(data) {
    if (Array.isArray(data)) return data;
    return data?.content ?? [];
}

function DiligenceListThumbType({data, pageInfo, dataHook}) {
    const navigate = useNavigate();
    const [searchTxt, setSearchTxt] = useState("");
    const rows = normalizeRows(data);

    const inputListener = (e) => {
        setSearchTxt(e.target.value);
    };

    const handleOnKeyPress = (e) => {
        if (e.key === "Enter") {
            // TODO: 통합검색 연동
        }
    };

    const handleItemClick = (each) => {
        const id = each?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(each, "실사 상세"),
            url: `/diligence/${id}`,
        });
    };

    return (
        <div className="simms-list-thumb list-container">
            <div className="list-container-top-search">
                <Input value={searchTxt} onChange={inputListener} onKeyPress={handleOnKeyPress} />
            </div>
            <div className="asset-thumbnail-container simms-list-thumb__scroll">
                {rows.map((each, rowIndex) => (
                    <div
                        key={each.id ?? rowIndex}
                        className="asset-thumb-item simms-list-thumb__item is-clickable mb-0 min-h-[120px] w-full cursor-pointer border bg-white p-1"
                        role="button"
                        tabIndex={0}
                        onClick={() => handleItemClick(each)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                handleItemClick(each);
                            }
                        }}
                    >
                        <DiligenceInfo data={each} />
                    </div>
                ))}
            </div>
            {rows.length > 0 && pageInfo ? (
                <CommonPagination page={pageInfo} onPageChange={dataHook?.handlePageChange} />
            ) : null}
        </div>
    );
}

export default DiligenceListThumbType;
